import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vn9q3djcqf: FaireBrandEntity = {
  token: "b_vn9q3djcqf",
  type: "brand",
  name: "Katmandu Trading Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/0ac5d67827cbf8d4e769d3adc24e104bdead77e5e7c256acf115e72aefd5b7e0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fdf043780433a8cd5df4d5a9f36405b13c491d49ad6a87287cd022b847ff0c64.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0ac5d67827cbf8d4e769d3adc24e104bdead77e5e7c256acf115e72aefd5b7e0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fdf043780433a8cd5df4d5a9f36405b13c491d49ad6a87287cd022b847ff0c64.jpeg",
  location: "Eugene, OR, USA",
  minimumOrderDollars: 139,
  rating: 4.6,
  reviewCount: 26,
  isInsider: true,
  description:
    "Locally owned/operated, shop the world with Katmandu, and find everything you never knew you always wanted! As an international family affair, Katmandu Trading Company specializes in bringing you handmade, exotic, merchandise from all corners of the globe. With an emphasis on Nepal, we offer handcrafted imports from over 40 countries. Whether it is wooden masks from Kathmandu, leather journals from Alexandria, cotton tapestries from Jaipur, or lapis lazuli from Kabul, all merchandise is consciously/ethically manufactured by proud members of our global family. Offering clothing styles for both men and women, sterling silver jewelry, hemp backpacks, winter wool, singing bowls, malas, incense/burners, and so much more, fair trade feels good!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:04.881Z",
    importedBy: "entity-db-cli",
  },
};
